import { render, staticRenderFns } from "./Inspektion_Mauer.vue?vue&type=template&id=68a06d8a&scoped=true&"
import script from "./Inspektion_Mauer.vue?vue&type=script&lang=js&"
export * from "./Inspektion_Mauer.vue?vue&type=script&lang=js&"
import style0 from "./Inspektion_Mauer.vue?vue&type=style&index=0&id=68a06d8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a06d8a",
  null
  
)

export default component.exports